import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const pdSchduleSchema: Schema = {
  title: 'PD Scheduling Activity',
  level: 2,
  columns: commonColumns
}
